<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <v-col cols="1">
          <v-btn icon dark disabled>
            <v-icon size="30">mdi-arrow-left-bold-box-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                dark
                v-bind="attrs"
                v-on="on"
                @click="import_dailog = true"
                class
                :disabled="selectedRows.length > 0"
              >
                <v-icon size="30">mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Import Cabinet</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length > 0"
                @click="addRecord()"
                class="ml-1"
              >
                <v-icon size="30">mdi-file-plus-outline</v-icon>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="opendEditPopup()"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
                class="ml-1"
              >
                <v-icon size="30">mdi-pencil-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <span>Edit Selected Records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-1">
                <v-icon size="30">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length < 1 || open_doc_model_falg || open_log_model_falg"
                @click="delete_dialog = true"
                class="ml-1"
              >
                <v-icon size="30">mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2" class="d-flex align-center">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon small dark v-bind="attrs" v-on="on" class="mr-1">
                <v-badge overlap dot :value="search" color="error">
                  <v-icon size="30">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  solo
                  clearable
                  autofocus
                  v-on:keyup.enter="search_menu = false"
                ></v-text-field>
              </v-col>
              </v-row>
            </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                :disabled="open_doc_model_falg || open_log_model_falg"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-0"
              >
                <v-badge
                  :content="filtersCount"
                  :value="filtersCount"
                  color="error"
                  overlap
                  size="30"
                >
                  <v-icon>mdi-filter-menu-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile max-width="300" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Vendor"
                    v-model="pagination.filters.vendor_id"
                    :items="vendor_list"
                    hide-details
                    item-text="vendor.v_name"
                    item-value="vendor.vendor_id"
                    class="body-2 pr-1"
                    placeholder="All"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Cabinet Line"
                    v-model="pagination.filters.cabinet_line_id"
                    :items="line_list"
                    hide-details
                    item-text="line.name"
                    item-value="line.cabinet_line_id"
                    class="body-2"
                    placeholder="All"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Color"
                    v-model="pagination.filters.cabinet_color_id"
                    :items="color_list"
                    hide-details
                    item-text="color.name"
                    item-value="color.cabinet_color_id"
                    class="body-2"
                    placeholder="All"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Type"
                    v-model="pagination.filters.cabinet_type_id"
                    :items="type_list"
                    hide-details
                    item-text="type.name"
                    item-value="type.cabinet_type_id"
                    class="body-2"
                    placeholder="All"
                    clearable
                  ></v-autocomplete>
                </v-list-item>

                <v-list-item class="mt-0">
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Accessory"
                    v-model="pagination.filters.accessory"
                    :items="status"
                    hide-details
                    class="body-2"
                  ></v-autocomplete>
                  <v-autocomplete
                    dense
                    flat
                    outlined
                    label="Modify"
                    v-model="pagination.filters.modify"
                    :items="status"
                    hide-details
                    class="body-2"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-1"
              >
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="30">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-1"
              >
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <v-icon size="30">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Cabinet</span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background: none" flat>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" class="pt-0 pr-0 alphabet-sort-max-width">
            <v-row dense class="alphabet-section">
              <v-col cols="12" class="text-center">
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :class="(pagination.filters.alphabet == '')?'primary':''"
                  class="text-capitalize"
                  @click="pagination.filters.alphabet = ''"
                >All</v-btn>
              </v-col>

              <v-col
                cols="12"
                v-for="(alphabet, index) in alphabets"
                :key="index"
                class="text-center pa-0"
                :style="alphabet.text == 'Z' 
                  ? 'padding-top: 1px !important; padding-bottom: 11px !important;' 
                  : 'padding-bottom: 2px !important;'"
              >
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:14px;"
                  :disabled="alphabet.disable"
                  :class="(pagination.filters.alphabet == alphabet.value) ? 'primary' : ''"
                  @click="pagination.filters.alphabet = alphabet.value"
                >{{ alphabet.text }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header custom-width-1328"
              item-key="cabinet_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              :show-expand="true"
              single-expand
              :expanded.sync="expanded"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item}">
                <tr>
                  <td width="2%">
                    <v-icon
                      @click="editRecord(item.cabinet_id,false)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="3%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                      @input="selectRecord(item.cabinet_id)"
                    ></v-simple-checkbox>
                  </td>
                  <td width="12%">{{item.name}}</td>
                  <td width="7%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ (item.vendor)?item.vendor.v_code:'' }}</span>
                      </template>
                      <span>{{(item.vendor)?item.vendor.v_name:''}}</span>
                    </v-tooltip>
                  </td>

                  <td width="9%">{{(item.type)?item.type.name:''}}</td>
                  <td width="5%">{{item.width}}</td>
                  <td width="5%">{{item.depth}}</td>
                  <td width="5%">{{item.height}}</td>
                  <td width="7%">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ (item.item)?item.item.short_name:'' }}</span>
                      </template>
                      <span>{{(item.item)?item.item.item_name:''}}</span>
                    </v-tooltip>
                  </td>
                  <td width="9%">{{(item.line)?item.line.name:''}}</td>
                  <td width="6%">{{item.list_px}}</td>
                  <td width="4%" class="text-center">{{(item.accessory)?'Yes':'No'}}</td>
                  <td width="9%">{{(item.color)?item.color.name:''}}</td>
                  <td width="4%" class="text-center">{{(item.modify)?'Yes':'No'}}</td>
                  <td width="5%" class="text-center">{{item.dr}}</td>
                  <td width="5%" class="text-center">{{item.drw}}</td>
                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.cabinet_id,true)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-eye-outline</v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_checkbox"
                  @input="changeSelectAll()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box"
                  :disabled="open_doc_model_falg || open_log_model_falg"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected cabinets?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteCabinets()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="import_dailog" max-width="400" persistent>
      <v-card :loading="import_dailog_loading">
        <v-card-title class="headline d-flex justify-center">Import Cabinet</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-file-input
                accept=".csv, .xlsx, .xls"
                v-model="selected_file"
                hide-details
                outlined
                placeholder="Select File"
                dense
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="import-btn">
          <v-btn color="error" dark @click="import_dailog = false; selected_file = null">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!selected_file"
            color="primary"
            dark
            @click="importData"
            :loading="import_dailog_loading"
          >Import</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="multi_update_records" max-width="400" persistent>
      <v-card :loading="multi_update_loading">
        <v-card-title class="headline">Update Selected Cabinets</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                dense
                label="Vendor"
                v-model="multi_update_data.vendor_id"
                :items="vendor_list_update"
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-1">
              <v-autocomplete
                dense
                label="Type"
                v-model="multi_update_data.cabinet_type_id"
                :items="type_list_update"
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-1">
              <v-autocomplete
                dense
                label="Item"
                v-model="multi_update_data.item_id"
                :items="item_list_update"
                item-text="item_name"
                item-value="item_id"
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-1">
              <v-autocomplete
                dense
                label="Cabinet Line"
                v-model="multi_update_data.cabinet_line_id"
                :items="line_list_update"
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-1">
              <v-autocomplete
                dense
                label="Color"
                v-model="multi_update_data.cabinet_color_id"
                :items="color_list_update"
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="multi_update_records = false; multi_update_data = {}">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="multi_update_loading" @click="updateCabinets">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Add />
    <Edit />
    <DocList />
    <LogList />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import Add from "./Add";
import Edit from "./Edit";
import { parseParams } from "../../plugins/helper";
import DocList from "../document/List";
import LogList from "../log/List";
import { mapMutations, mapState } from "vuex";
export default {
  name: "CabinetList",
  data() {
    return {
      open_doc_model_falg: false,
      open_log_model_falg: false,
      showMenu: false,
      import_dailog_loading: false,
      search: "",
      items: {
        data: []
      },
      import_dailog: false,
      select_all_checkbox: false,
      multi_update_records: false,
      multi_update_loading: false,
      selected_file: null,
      loading: false,
      delete_dialog: false,
      filter_menu: false,
      multi_update_data: {},
      vendor_list: [],
      line_list: [],
      color_list: [],
      type_list: [],
      status: [
        {
          text: "All",
          value: ""
        },
        {
          text: "Yes",
          value: "1"
        },
        {
          text: "No",
          value: "0"
        }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["name"],
        page: 1,
        filters: {
          alphabet: "",
          vendor_id: "",
          cabinet_type_id: "",
          cabinet_line_id: "",
          cabinet_color_id: "",
          modify: "",
          accessory: ""
        }
      },
      alphabets: [],
      expanded: [],
      type_list_update: [],
      color_list_update: [],
      line_list_update: [],
      item_list_update: [],
      vendor_list_update: [],
      search_menu: false
    };
  },
  components: {
    Add,
    Edit,
    DocList,
    LogList
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("cabinet", ["add_modal", "edit_modal"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    filtersCount() {
      let count = 0;
      for (var key in this.pagination.filters) {
        if (this.pagination.filters[key] && key != "alphabet") {
          count++;
        }
      }
      if (count == 0) {
        return "D";
      } else {
        return count;
      }
    },
    headers() {
      return [
        { value: "", text: "", sortable: false, width: "2%" },
        { value: "select_all", text: "", sortable: false, width: "3%" },
        { value: "name", text: "Name", sortable: true, width: "12%" },
        { value: "", text: "Vendor", sortable: false, width: "7%" },
        { value: "", text: "Type", width: "9%", sortable: false },
        { value: "", text: "W", sortable: false, width: "5%" },
        { value: "", text: "D", sortable: false, width: "5%" },
        { value: "", text: "H", sortable: false, width: "5%" },
        { value: "", text: "Item", sortable: false, width: "7%" },
        { value: "", text: "Cabinet Line", sortable: false, width: "9%" },
        { value: "", text: "List Px", sortable: false, width: "6%" },
        { value: "", text: "Acc.", sortable: false, width: "4%" },
        { value: "", text: "Color", sortable: false, width: "9%" },
        { value: "", text: "MDFY", sortable: false, width: "4%" },
        { value: "", text: "Door", sortable: false, width: "5%" },
        { value: "", text: "Drawer", sortable: false, width: "5%" },
        { value: "", text: "", sortable: false, width: "3%" }
      ];
    },
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      return paginationData;
    }
  },
  watch: {
    search() {
      this.getCabinets();
    },
    pagination: {
      handler: function() {
        this.getCabinets();
      },
      deep: true
    },
    add_modal: function(value) {
      if (!value) {
        this.pagination.filters.alphabet = "";
        this.resetFilter();
      }
    },
    edit_modal: function(value) {
      if (!value) {
        this.getCabinets();
      }
    },
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    }
  },
  methods: {
    ...mapMutations("cabinet", ["setData"]),
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.cabinet_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 3 });
      this.setDocumentData({ key: "o_id", value: item.cabinet_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "form_name", value: "Cabinet" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "bank_name", value: "" });

      this.setDocumentData({ key: "project_name", value: "" });

      if (item.vendor) {
        this.setDocumentData({ key: "vendor_name", value: item.vendor.v_name });
      } else {
        this.setDocumentData({ key: "vendor_name", value: "" });
      }
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 3 });
      this.setLogData({ key: "o_id", value: item.cabinet_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "Cabinet" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: "" });
      this.setLogData({ key: "customer_name", value: "" });
      this.setLogData({ key: "bank_name", value: "" });

      this.setLogData({ key: "project_name", value: "" });

      if (item.vendor) {
        this.setLogData({ key: "vendor_name", value: item.vendor.v_name });
      } else {
        this.setLogData({ key: "vendor_name", value: "" });
      }
    },
    opendEditPopup() {
      this.multi_update_records = true;
    },
    updateCabinets() {
      let _self = this;
      this.multi_update_loading = true;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.cabinet_id);
      });
      this.multi_update_data.ids = ids;

      axios
        .post("update_cabinets", this.multi_update_data)
        .then(function() {
          _self.getCabinets();
          _self.multi_update_data = {};
          _self.multi_update_loading = false;
          _self.multi_update_records = false;
        })
        .catch(function() {
          _self.multi_update_loading = false;
        });
    },
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.items.data = this.items.data.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    importData() {
      let _self = this;
      this.import_dailog_loading = true;
      let formData = new FormData();
      formData.append("csv_file", this.selected_file);
      axios
        .post("import_cabinet", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          if (response.data.status) {
            _self.getCabinets();
            _self.import_dailog_loading = false;
            _self.import_dailog = false;
            _self.selected_file = null;
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.import_dailog_loading = false;
        });
    },
    resetFilter() {
      this.search = "";
      this.pagination.filters.vendor_id = "";
      this.pagination.filters.cabinet_type_id = "";
      this.pagination.filters.cabinet_line_id = "";
      this.pagination.filters.cabinet_color_id = "";
      this.pagination.filters.modify = "";
      this.pagination.filters.accessory = "";
      this.getCabinets();
    },
    addRecord() {
      this.setData({ key: "add_modal", value: true });
    },
    editRecord(cabinet_id, is_view_mode) {
      this.setData({ key: "edit_modal", value: true });
      this.setData({ key: "id", value: cabinet_id });
      this.setData({ key: "is_view_mode", value: is_view_mode });
    },
    getAlphabets() {
      this.loading = true;
      axios.get("get_alphabets?flag=cabinet").then(response => {
        if (response.data.status) {
          this.alphabets = response.data.data;
        }
        this.loading = false;
      });
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.cabinet_id == itemData.item.cabinet_id) {
            item.selected = true;
          }
          return item;
        });
      }
    },
    deleteCabinets() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.cabinet_id);
      });
      axios
        .post("delete_cabinets", {
          ids: ids
        })
        .then(function() {
          _self.getCabinets();
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.$Progress.fail();
        });
    },
    getCabinets() {
      let _self = this;
      this.loading = true;
      let url = parseParams(this.pageData);
      axios
        .get("cabinet_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.vendor_list = response.data.vendors;
          _self.line_list = response.data.lines;
          _self.color_list = response.data.colors;
          _self.type_list = response.data.types;
          _self.alphabets = response.data.alphabets;
          _self.select_all_checkbox = false;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getVendors() {
      this.loading = false;
      let _self = this;
      axios
        .get("get_cabinet_vendor")
        .then(response => {
          console.log(response);
          _self.vendor_list_update = response.data.data;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getItems() {
      this.loading = false;
      let _self = this;
      axios
        .get("items_list?itemsPerPage=-1&item_type='0'")
        .then(response => {
          _self.item_list_update = response.data.data.data;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getCabinetSelector() {
      this.loading = false;
      let _self = this;
      axios
        .get("cabinet_selector")
        .then(response => {
          _self.type_list_update = response.data.data.type;
          _self.color_list_update = response.data.data.color;
          _self.line_list_update = response.data.data.line;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    }
  },
  mounted: function() {
    //this.getAlphabets();
    this.getVendors();
    this.getItems();
    this.getCabinetSelector();
  }
};
</script>